import React from "react"
import { getIn } from "formik"
import NumberFormat from "react-number-format"
import "./PriceField.css"

const PriceField = props => {
  const {
    field,
    form: { touched, errors },
    currency
  } = props
  let status = "default"
  if (getIn(touched, field.name) && getIn(errors, field.name)) {
    status = "has-error"
  } else if (
    getIn(touched, field.name) &&
    field.value &&
    !getIn(errors, field.name)
  ) {
    status = "is-fixed"
  }
  return (
    <div className={`PriceField ${status}`}>
      <span className="price-currency">{currency}</span>
      {/* <input {...field} {...props} placeholder="0.00" /> */}
      {/* <NumberField thousandSeparator="," {...props} allowNegative={false} /> */}
      <NumberFormat
        className={status}
        value={field.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
        name={field.name}
        thousandSeparator=","
        {...props}
        allowNegative={false}
      />
      {touched[field.name] &&
        errors[field.name] && (
          <div className="error-message">{errors[field.name]}</div>
        )}
    </div>
  )
}

export default PriceField
